import { get, post } from './../Config/config';

export const ProjectUsers = {
    // Get project-specific users
    getProjectUsers: (data) => get('/list-project-users', { params: data }),
    
    // Update user priorities
    updatePriorities: (data) => post('/project-users/update-priorities', data),
}